import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import stateList from '../../../../utils/stateList.json';

const ExportAll = (props) => {
  const { taxData,searchType,bookingNumber,startDate,endDate,year } = props;
  const exportMapping = [
    {
      header: 'Booking Number',
      value: (row) => `${row.bookingNumber}`
    },
    {
      header: 'Customer Name',
      value: (row) => `${row.customerName}`
    },
    {
      header: 'Customer Address',
      value: (row) => `${row.customerAddress}`
    },
    {
      header: 'State',
      value: (row) => `${row.state}`
    },
    {
      header: 'State Code',
      value: (row) => `${stateList.find(s => s.name == row?.expert?.UserAddress?.state)?.code || ''}`
    },
    {
      header: 'serviceDate',
      value: (row) => row.serviceDate ? `="${row.serviceDate}"` : ''
    },
    {
      header: 'Charge Type',
      value: (row) => `${row.chargeType}`
    },
    {
      header: 'Service Name',
      value: (row) => `${row.serviceName ||''}`
    },
    {
      header: 'Sac Code',
      value: (row) => `${row.sacCode || ''}`
    },
    {
      header: 'RCM',
      value: (row) => `${row.rcm || ''}`
    },
    {
      header: 'Quantity',
      value: (row) => `${row.quantity}`
    },
    {
      header: 'Unit Price',
      value: (row) => `${row.unitPrice}`
    },
    {
      header: 'Base Amount',
      value: (row) => `${row.baseAmount}`
    },
    {
      header: 'Coin Disc.',
      value: (row) => `${row.coinDiscount}`
    },
    {
      header: 'Coupon Disc.',
      value: (row) => `${row.couponDiscount}`
    },
    {
      header: 'Taxable Amt.',
      value: (row) => `${row.taxableAmount}`
    },
    {
      header: 'IGST',
      value: (row) => `${row.igst}`
    },
    {
      header: 'CGST',
      value: (row) => `${row.cgst}`
    },
    {
      header: 'SGST',
      value: (row) => `${row.sgst}`
    },
    {
      header: 'IGST_NON',
      value: (row) => `${row.igstNon}`
    },
    {
      header: 'CGST_NON',
      value: (row) => `${row.cgstNon}`
    },
    {
      header: 'SGST_NON',
      value: (row) => `${row.sgstNon}`
    },
    {
      header: 'TCS',
      value: (row) => `${row.tcs}`
    },
    {
      header: 'Total GST',
      value: (row) => `${row.totalGst}`
    },
    {
      header: 'Final Amount',
      value: (row) => `${row.totalAmount}`
    },
    {
      header: 'GST Rate',
      value: (row) => `${row.taxRate}`
    },
  ];

  const handleExportAllRows = async () => {
    try {
      // Swal.fire({
      //   title: 'Exporting Data',
      //   text: 'Please wait while we prepare your download...',
      //   icon: 'info',
      //   allowOutsideClick: false,
      //   didOpen: () => {
      //     Swal.showLoading();
      //   }
      // });

      // Transform data using custom mapping
      const exportData = taxData.map(row => {
        return exportMapping.reduce((acc, field) => {
          acc[field.header] = field.value(row);
          return acc;
        }, {});
      });

      // Create CSV content
      const headers = exportMapping.map(field => `"${field.header}"`).join(',');
      const csvContent = exportData.map(row => 
        exportMapping.map(field => 
          `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
        ).join(',')
      );

      csvContent.unshift(headers);

      // Create and download file
      const csvString = csvContent.join('\n');
      const blob = new Blob(['﻿', csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const fileName = searchType === 'year' 
                      ? `booking-tax-summary-${year}` 
                      : searchType === 'booking' 
                          ? `booking-tax-summary-${bookingNumber}` 
                          : `booking-tax-summary-${dayjs(startDate).format('DD-MM-YYYY')}_to_${dayjs(endDate).format('DD-MM-YYYY')}`;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Export Successful',
        html: `
          <p>If download doesn't start automatically, click on provided link:
          <a href="${url}" download="${fileName}.csv" style="color: blue; text-decoration: underline;">
            Download CSV
          </a></p>
        `,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });

    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };

  return (
    <Box>        
      <Button 
        onClick={handleExportAllRows}
        startIcon={<SaveAlt />}
        sx={{textTransform:'none'}}
      >
        Export
      </Button>      
    </Box>
  );
}

export default ExportAll;